module.exports = __webpack_public_path__ + "static/media/UG.5d42cbb9.svg";